export default __webpack_public_path__ + "static/media/Cedlabs.4a83eae7.png";